export const appStoreLink =
  'https://apps.apple.com/app/giantleap-evaluation-game/id1493386012?ign-mpt=uo%3D2'
export const googlePlayLink =
  'https://play.google.com/store/apps/details?id=com.giantleap.assessmentgame&hl=en'



// WEBPACK FOOTER //
// ./src/config/appLinks.ts